import './NotFoundPage.scss';

export function NotFoundPage() {
  return (
    <main className="not-found-page">
      <div className="not-found-page__container">
        <div className="not-found-page__content">
          <span className="not-found-page__code">404</span>
          <h1 className="not-found-page__title">Request Not Found</h1>
          <p className="not-found-page__message">
            The shared request you are looking for does not exist or may have been removed.
          </p>
        </div>
      </div>
    </main>
  );
}
